let url = window.location.href;
if (url.indexOf("?ueberuns=bpv") != -1) {
	$("#m-bestpreis-versprechen-start").modal("show");
}